import { render, staticRenderFns } from "./GroupCategoryForm.vue?vue&type=template&id=52231b78"
import script from "./GroupCategoryForm.vue?vue&type=script&lang=js"
export * from "./GroupCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports